import React, { useState, useEffect } from "react";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";
import covidVaccineOptions from "./data/covidVaccineOptions.json";
import Dropdown from "react-dropdown-select";
import { customSelectStyles2,alignedContentRenderer, paddedItemRenderer } from "../../../util_functions/helpers";


const ImmunisationComponent = ({ user }) => {
  const [selection, setSelection] = useState("");
  const [selectedOption, setSelectedOption] = useState(covidVaccineOptions[0]);
  const [validationError, setValidationError] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => { 
    if (!user?.id) return;
  
    const fetchImmunizationData = async () => {
      try {
        const { data: fetchedUserData } = await axios.get(
          `${baseURL}/v1/worker-users/${user.id}`
        );
        const immunizationData = fetchedUserData?.immunizationStatus;
        if (!immunizationData) return;
  
        if (immunizationData.covidVaccineStatus) {
          const matchedOption = covidVaccineOptions.find(
            (opt) => opt.value === immunizationData.covidVaccineStatus
          );
          if (matchedOption) {
            console.log("Setting selectedOption to:", matchedOption);
            setSelectedOption(matchedOption);
          } else {
            console.error("Unknown COVID vaccine status:", immunizationData.covidVaccineStatus);

          }
        }
    
        if (immunizationData.fluVaccineStatus === "yes" || immunizationData.fluVaccineStatus === "no") {
          setSelection(immunizationData.fluVaccineStatus);
        } else {
          console.error("Unknown flu vaccine status:", immunizationData.fluVaccineStatus);
        }
      } catch (err) {
        console.error("Failed to fetch immunization data:", err);
      }
    };
  
    fetchImmunizationData();
  }, [user?.id, baseURL]);
  
  useEffect(() => {
    console.log("Updated COVID Vaccine Status:", selectedOption);
    console.log("Updated Flu Vaccine Status:", selection);
  }, [selectedOption, selection]);

  const handleDropdownChange = (e) => {
    const value = e.target.value;
    console.log("Radio checked value:", value);
    setSelectedOption(value);
    setValidationError("");
  };

  const handleRadioChange = (e) => {
    setSelection(e.target.value);
    setValidationError("");
  };
  

  const handleSave = async () => {
    setIsFormSubmitted(false);
    setValidationError("");
  
    if (!selectedOption || (selection !== "yes" && selection !== "no")) {
      setValidationError("Please make all required selections.");
      return;
    }
  
    try {
      const response = await axios.patch(
        `${baseURL}/v1/worker-users/${user.id}`,
        {
          immunization: {
            covidVaccineStatus: selectedOption.value,
            fluVaccineStatus: selection,
          },
        }
      );
      if (response.data) {
        console.log("Patch successful");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Failed to update badge selections", error);
    }
  };
  

  return (
    <div className="immunization-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Vaccines / Immunization</h2>
        </div>
      
      <div className="immunization-indicative-above-div">
        <p>
          To provide services via <strong>One Support Hub</strong>, you
          acknowledge that you’ve met and will continue to meet any vaccination
          requirements in your state and territory and for your services.{" "}
        </p>
      </div>
      <div className="immunization-vaccination-requirement">
        <h3>
        Are your COVID-19 vaccinations current with local guidelines?
        </h3>
         <Dropdown
    options={covidVaccineOptions}
    values={[selectedOption]} 
    onChange={(values) => {
      console.log("Dropdown onChange, selected value:", values[0]);
      setSelectedOption(values[0]);
      setValidationError("");
    }}
    placeholder="Select option"
    style={customSelectStyles2(false)}
    contentRenderer={alignedContentRenderer}
  itemRenderer={paddedItemRenderer}
  />
      </div>
      <div className="immunization-flu-vaccine">
        <h3>Flu Vaccine</h3>
        <p>
          A flu shot is required and recommended for Home Care. Clients or
          providers can ask if you’ve been vaccinated for flu this year. Make
          sure you have prepared evidence to show them you have. If you answer
          yes, a flu vaccine badge will appear on your profile and can be viewed
          by clients.
        </p>
      </div>
      <div className="immunization-flu-answer">
        <h3>Have you received the flu shot for this season?</h3>
          <div className="immunization-badge-option">
          <div className="radio-container">
          <div className="radio-item">
          <input
                type="radio"
                id="yes"
                name="applyCheck"
                value="yes"
                checked={selection === "yes"}
              onChange={handleRadioChange}
              />
              <label htmlFor="yes">Yes</label>
            </div>
            <div className="radio-item">
            <input
                type="radio"
                id="no"
                name="applyCheck"
                value="no"
                checked={selection === "no"}
              onChange={handleRadioChange}
              />
              <label htmlFor="no">No</label>
            </div>
          </div>
        </div>
      </div>
      {validationError && (
        <div className="immunization-error">{validationError}</div>
      )}
      <div className="immunization-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default ImmunisationComponent;
